// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__33mBf","actions":"GroupTable_actions__1_7tl","deleteModalFooter":"GroupTable_deleteModalFooter__3uB4v"};